export default __webpack_public_path__ + "static/sean-bbb9982cc9b07f13c2962b7bb65971fa.jpg";